import { render, staticRenderFns } from "./SubscriptionFeeConfiguration.vue?vue&type=template&id=136ab2ce&"
import script from "./SubscriptionFeeConfiguration.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFeeConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports